export default "https://dakcheck.solease.nl/static/media/minus.55cce62b.svg";